export default class Processor {

    constructor(data) {
        this.id = null;
        this.name = null;

        if (data) {
            Object.assign(this, data);
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/processor.model.js